exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer{\r\n    width: 100%;\r\n    background-color: #222;\r\n    padding: 60px 0px;\r\n}\r\n\r\nnav{\r\n    float: left;\r\n}\r\n\r\nnav ul li{\r\n    display: inline-block;\r\n    margin-left: 20px;\r\n    list-style-type: none;\r\n}\r\n\r\nnav ul li a {\r\n    font-weight: 400;\r\n    font-size: 10px;\r\n    color: #FFF;\r\n}\r\n\r\n.centered p{\r\n    color: #FFF;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-top: 40px;\r\n    margin-bottom: 0px;\r\n \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/components/footer/footer.component.css
// module id = ../../../../../src/app/components/footer/footer.component.css
// module chunks = main